<div class="container-testimonials" [ngStyle]="{'padding-bottom': _padding ? '180px': '60px'}">
  <div class="row container-fluid container-lg">
    <div class="col-12">
      <div class="home-subtitle" [innerHTML]="_title | safe: 'html'">
      </div>
    </div>
  </div>
</div>
